import { render, staticRenderFns } from "./StarShooting.vue?vue&type=template&id=2796c6f2&"
import script from "./StarShooting.vue?vue&type=script&lang=js&"
export * from "./StarShooting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports